import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import $ from 'jquery';
import { decodeHtmlEntities} from "../containers/utils";

import ucfirst from '../tools/ucfirst';
import ProgressBar from '../components/ProgressBar';
import AcceptLeadButton from '../components/AcceptLeadButton';
import TeamLeadPurchaseLimit from './TeamLeadPurchaseLimit'

const valueToLocaleString = (value) => {
  if (value) {
    return value.toLocaleString();
  }

  return value;
};

class OpportunityView extends React.Component {
  render() {
    const isAvailable = this.props.lead.places >= 1;

    const canAcceptLead = !isAvailable ? (
      <div className="l-lead-modal-section t-content">
        <p>This lead now been sent to the maximum number of teams.</p>
      </div>
    ) : '';

    const acceptLead = isAvailable ? (
      <div className="l-lead-modal-cta-confirm">
        <AcceptLeadButton
            lead={this.props.lead}
            price={this.props.lead.price}
            currency={this.props.lead.currency}
        />
      </div>
    ) : '';

    let qualificationType = this.props.lead.qualification_type;
    if (typeof qualificationType === 'string') {
      qualificationType = this.props.lead.qualification_type.split('_')
        .map(text => text.charAt(0).toUpperCase() + text.substr(1))
        .join(' ');
    }

    let companyDescriptor = this.props.lead.companydescriptor;
    if (typeof companyDescriptor === 'string') {
      companyDescriptor = this.props.lead.companydescriptor.charAt(0).toUpperCase() +
        this.props.lead.companydescriptor.substr(1);
    }

    const table = [];
    // The original field is used to check whether a value is null even if it
    // has been modified e.g. appending million to revenue means it is
    // 'null million' rather null when there is no value.
    let tableData = [
      {
        name: 'Lead Type',
        value: qualificationType,
      },
      {
        name: 'Market',
        value: this.props.lead.market_name,
      },
      {
        name: 'Country',
        value: decodeHtmlEntities(this.props.lead.country_name),
      },
      {
        name: 'Industry Sector',
        value: this.props.lead.industry_sector,
      },
      {
        name: 'Company Descriptor',
        value: companyDescriptor,
      },
      {
        name: 'Project Timeframe',
        value: this.props.lead.timeframe,
      },
      {
        name: 'Campaign',
        value: this.props.lead.campaign,
      },
      {
        name: 'Download',
        value: this.props.lead.download,
      },
      {
        name: 'Download Url',
        value: this.props.lead.download_url,
      },
      {
        name: 'Download Name',
        value: this.props.lead.download_name,
      },
      {
        name: 'Estimated Budget',
        value: this.props.lead.estimated_budget,
      },
      {
        name: 'Page name',
        value: decodeHtmlEntities(this.props.lead.pagename),
      },
      {
        name: 'Reasons for project',
        value: decodeHtmlEntities(this.props.lead.reasonforproject),
      },
      {
        name: 'Required features',
        value: decodeHtmlEntities(this.props.lead.requiredfeatures),
      },
      {
        name: 'Required functions',
        value: decodeHtmlEntities(this.props.lead.requiredfunctions),
      },
      {
        name: 'Requirements',
        value: decodeHtmlEntities(this.props.lead.requirements),
      },
      {
        name: 'Using HR?',
        value: this.props.lead.usinghr,
      },
      {
        name: 'Using ERP?',
        value: this.props.lead.usingerp,
      },
      {
        name: 'UID',
        value: this.props.lead.uid,
      },
      {
        name: 'Inpatient Outpatient',
        value: this.props.lead.inpatientoutpatient,
      },
      {
        name: 'Orders per Day',
        value: this.props.lead.ordersperday,
      },
      {
        name: 'Current vendor',
        value: decodeHtmlEntities(this.props.lead.currentvendor),
      },
    ];

    switch (this.props.lead.market_name) {
      case 'ERP':
        tableData = [
          {
            name: 'Lead Type',
            value: qualificationType,
          },
          {
            name: 'Market',
            value: decodeHtmlEntities(this.props.lead.market_name),
          },
          {
            name: 'Company Descriptor',
            value: companyDescriptor,
          },
          {
            name: 'Industry Category',
            value: decodeHtmlEntities(this.props.lead.industry_sector),
          },
          {
            name: 'Industry Sub Category',
            value: this.props.lead['industrysub-category'],
          },
          {
            name: 'Company Revenue',
            value: `${this.props.lead.actual_revenue}`,
            original: this.props.lead.actual_revenue,
          },
          {
            name: 'Number of employees',
            value: valueToLocaleString(this.props.lead.actual_number_of_employees),
          },
          {
            name: 'Number of users',
            value: valueToLocaleString(this.props.lead.actual_number_of_users),
          },
          {
            name: 'Purchase Timeframe',
            value: this.props.lead.timeframe,
          },
          {
            name: 'Reasons for Purchase',
            value: decodeHtmlEntities(this.props.lead.reasonforproject),
          },
          {
            name: 'Download URL',
            value: this.props.lead.download_url,
          },
          {
            name: 'Current vendor',
            value: decodeHtmlEntities(this.props.lead.currentvendor),
          },
        ];
        break;
      case 'HRMS':
        tableData = [
          {
            name: 'Lead Type',
            value: qualificationType,
          },
          {
            name: 'market',
            value: this.props.lead.market_name,
          },
          {
            name: 'Company Descriptor',
            value: companyDescriptor,
          },
          {
            name: 'Number of Employees',
            value: valueToLocaleString(this.props.lead.numberofemployeesnonrange),
          },
          {
            name: 'Industry',
            value: decodeHtmlEntities(this.props.lead.sagecampaignindustries),
          },
          {
            name: 'Purchase Timeframe',
            value: this.props.lead.timeframe,
          },
          {
            name: 'Reasons for Purchase',
            value: decodeHtmlEntities(this.props.lead.reasonforproject),
          },
          {
            name: 'Required Functions',
            value: decodeHtmlEntities(this.props.lead.requiredfunctions),
          },
          {
            name: 'Download URL',
            value: this.props.lead.download_url,
          },
          {
            name: 'Current vendor',
            value: decodeHtmlEntities(this.props.lead.currentvendor),
          },
        ];
        break;
      case 'EHR':
        tableData = [
          {
            name: 'Lead Type',
            value: qualificationType,
          },
          {
            name: 'Specialty',
            value: decodeHtmlEntities(this.props.lead.practicespecialty),
          },
          {
            name: 'market',
            value: decodeHtmlEntities(this.props.lead.market_name),
          },
          {
            name: 'Number of Physicians',
            value: this.props.lead.practicesizenonrange,
          },
          {
            name: 'Number of Users',
            value: valueToLocaleString(this.props.lead.numberofusers),
          },
          {
            name: 'Purchase Timeframe',
            value: this.props.lead.timeframe,
          },
          {
            name: 'Reasons for Purchase',
            value: decodeHtmlEntities(this.props.lead.reasonforproject),
          },
          {
            name: 'Required Functions',
            value: decodeHtmlEntities(this.props.lead.requiredfunctions),
          },
          {
            name: 'Download URL',
            value: this.props.lead.download_url != null ?
              this.props.lead.download_url :
              this.props.lead.downloadurl,
          },
          {
            name: 'Inpatient Outpatient',
            value: this.props.lead.inpatientoutpatient,
          },
          {
            name: 'Current vendor',
            value: decodeHtmlEntities(this.props.lead.currentvendor),
          },
        ];
        break;
      case 'CRM':
        tableData = [
          {
            name: 'Lead Type',
            value: qualificationType,
          },
          {
            name: 'market',
            value: this.props.lead.market_name,
          },
          {
            name: 'Industry',
            value: decodeHtmlEntities(this.props.lead.industry_sector),
          },
          {
            name: 'Number of Employees',
            value: valueToLocaleString(this.props.lead.numberofemployees),
          },
          {
            name: 'Number of Users',
            value: valueToLocaleString(this.props.lead.numberofusers),
          },
          {
            name: 'Purchase Timeframe',
            value: this.props.lead.timeframe,
          },
          {
            name: 'Reasons for Purchase',
            value: decodeHtmlEntities(this.props.lead.reasonforproject),
          },
          {
            name: 'Required Functions',
            value: decodeHtmlEntities(this.props.lead.requiredfunctions),
          },
          {
            name: 'Download URL',
            value: this.props.lead.download_url,
          },
          {
            name: 'Current vendor',
            value: decodeHtmlEntities(this.props.lead.currentvendor),
          },
        ];
        break;
      case 'WMS':
        tableData = [
          {
            name: 'Lead Type',
            value: qualificationType,
          },
          {
            name: 'market',
            value: decodeHtmlEntities(this.props.lead.market_name),
          },
          {
            name: 'Industry Sector',
            value: decodeHtmlEntities(this.props.lead.industry_sector),
          },
          {
            name: 'Annual Revenue',
            value: this.props.lead.revenue,
          },
          {
            name: 'Number of Employees',
            value: valueToLocaleString(this.props.lead.numberofemployees),
          },
          {
            name: 'Number of Users',
            value: valueToLocaleString(this.props.lead.numberofusers),
          },
          {
            name: 'Purchase Timeframe',
            value: this.props.lead.timeframe,
          },
          {
            name: 'Reasons for Purchase',
            value: decodeHtmlEntities(this.props.lead.reasonforproject),
          },
          {
            name: 'Required Functions',
            value: decodeHtmlEntities(this.props.lead.requiredfunctions),
          },
          {
            name: 'Orders per Day',
            value: this.props.lead.ordersperday,
          },
          {
            name: 'Download URL',
            value: this.props.lead.download_url,
          },
          {
            name: 'Current vendor',
            value: decodeHtmlEntities(this.props.lead.currentvendor),
          },
        ];
        break;
      case 'PLM':
        tableData = [
          {
            name: 'Lead Type',
            value: qualificationType,
          },
          {
            name: 'Country',
            value: decodeHtmlEntities(this.props.lead.country_name),
          },
          {
            name: 'Industry Sector',
            value: decodeHtmlEntities(this.props.lead.industry_sector),
          },
          {
            name: 'Project Timeframe',
            value: this.props.lead.timeframe,
          },
          {
            name: 'Revenue',
            value: this.props.lead.revenue_formatted,
          },
          {
            name: 'Download',
            value: this.props.lead.download,
          },
          {
            name: 'Download Url',
            value: this.props.lead.download_url,
          },
          {
            name: 'Download Name',
            value: decodeHtmlEntities(this.props.lead.download_name),
          },
          {
            name: 'Estimated Budget',
            value: this.props.lead.estimated_budget,
          },
          {
            name: 'Page name',
            value: decodeHtmlEntities(this.props.lead.pagename),
          },
          {
            name: 'Reasons for project',
            value: decodeHtmlEntities(this.props.lead.reasonforproject),
          },
          {
            name: 'Required features',
            value: decodeHtmlEntities(this.props.lead.requiredfeatures),
          },
          {
            name: 'Required functions',
            value: decodeHtmlEntities(this.props.lead.requiredfunctions),
          },
          {
            name: 'Requirements',
            value: decodeHtmlEntities(this.props.lead.requirements),
          },
          {
            name: 'Current vendor',
            value: decodeHtmlEntities(this.props.lead.currentvendor),
          },
        ];
        break;
      default:
        break;
    }

    tableData.forEach((row) => {
      if (row.original === null) {
        return;
      }

      if (row.value) {
        if (Array.isArray(row.value)) {
          table.push((
            <div key={row.name} className="detail-table-item">
              <div className="detail-table-definition">
                {row.name}
              </div>
              <div className="detail-table-value">
                {row.value.join(', ')}
              </div>
            </div>
          ));
        } else if (typeof (row.value) === 'boolean') {
          table.push((
            <div key={row.name} className="detail-table-item">
              <div className="detail-table-definition">
                {row.name}
              </div>
              <div className="detail-table-value">
                {row.value ? 'Yes' : 'No'}
              </div>
            </div>
          ));
        } else {
          table.push((
            <div key={row.name} className="detail-table-item">
              <div className="detail-table-definition">
                {row.name}
              </div>
              <div className="detail-table-value">
                {$('<textarea />').html(row.value).text()}
              </div>
            </div>
          ));
        }
      }
    });

    const leadData = table.reduce((acc, current) => {
      if (acc[acc.length - 1].length >= 3) {
        acc.push([]);
      }

      acc[acc.length - 1].push(current);

      return acc;
    }, [[]]).map((row, i) => (
      <div key={i} className="detail-table-row">
        {row}
      </div>
    ));

    let debug = '';
    // if (this.props.lead.scoring_debug_url) {
    //   debug = <a href={this.props.lead.scoring_debug_url} className="btn btn--primary">Debug Scoring</a>;
    // }

    const comments = this.props.lead.anonymised_comments.split('\n').map(((comment, id) => <p key={id}>{$('<textarea />').html(comment).text()}</p>));

    return (
      <div>
        <div className="l-lead-modal">
          <header className="l-lead-modal-section">
            {/*<div>*/}
            {/*  <span className="l-lead-modal__label">*/}
            {/*    /!*{qualificationType}*!/*/}
            {/*  </span>*/}
            {/*</div>*/}
            <h1 className="t-header">{$('<textarea />').html(this.props.lead.headline).text()}</h1>
          </header>

          <div className="l-lead-modal-divider comment">
            <header className="comment-header">
              <div className="comment-author">
                {/*<span className="comment-author-name">Qualified by {ucfirst(this.props.lead.verifiedby)}</span>*/}
              </div>
              <div className="comment-date">
                Qualified on:&nbsp;
                {
                  this.props.lead.qualified_at ?
                    moment(this.props.lead.qualified_at, 'M/D/YYYY HH:mm:ss a').format('MM/DD/YYYY')
                    : ''
                }
              </div>
            </header>
            <div className="comment-content">
              {comments}
            </div>
          </div>

          {debug}

          <div className="l-lead-modal-section detail-table">
            {leadData}
          </div>

          {canAcceptLead}

          <TeamLeadPurchaseLimit />
          <footer className="l-lead-modal-section l-lead-modal-ctas">
            {window.teamLeadPurchaseLimit !== 0 ? acceptLead : null}
            <div className="l-lead-modal-cta-ignore">
              <button type="button" onClick={this.props.onClose} className="btn btn--emphasis btn--block btn--muted">Close</button>
            </div>
          </footer>

          <small className="t-small">
            Lead UID: { this.props.lead.uid }
          </small>
        </div>
      </div>
    );
  }
}

OpportunityView.propTypes = {
  lead: PropTypes.object.isRequired,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(OpportunityView);
